export default {
	subtitle: "",
	path: "webhooks_subscription_invoice_paid",
	paragraphs: [
		"This notification is send when an invoice related to a subscription is paid.",
	],
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"secret": "the value you received",
						"type": "invoice_paid",
						"invoice": {
							"id": "d5dbfff5-7391-447b-a642-a57af80b09db",
							"status": "paid",
							"subject_id": "7c6afdd6-eb4b-4113-93c6-95be304ea9cc",
							"subscription_id": "991740dd-d1d3-4f80-81ad-7062388aaedc"
						},
					}
				}
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationSubscriptionInvoicePaid.js